import script from "./parental.vue?vue&type=script&setup=true&lang=ts"
export * from "./parental.vue?vue&type=script&setup=true&lang=ts"

import "./parental.vue?vue&type=style&index=0&id=4e3b8ade&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e3b8ade"]])

export default __exports__